import { createContext } from 'react';

import type { AppService } from '../services/AppService';

// @ts-ignore
export const AppContext = createContext<AppService>(null);
